import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';

import { GridArrowRight } from '../../../../assets/svg';
import { Target } from '../../../../client';
import RoundedButtonWithIcon from '../../../../components/RoundedButtonWithIcon';
import useRouter from '../../../../hooks/useRouter';
import { StateType } from '../../../../states';

import selectMissionDetailsBetRedirectionButtonContainerProps from './MissionDetailsBetRedirectionButton.selector';

const StyledPrimaryButton = styled(RoundedButtonWithIcon)`
  height: 2.4em;

  transition: none 200ms ease-in-out;
  transition-property: transform, filter;
  user-select: none;
  -webktip-tap-highlight: transparent;

  ${Target.__MOBILE__
    ? css`
        &:active {
          transform: scale(0.95);
        }
      `
    : css`
        &:hover,
        &:active {
          filter: brightness(120%);
        }
        &:active {
          transform: scale(0.95);
        }
      `}
`;

type MissionDetailsBetRedirectionButtonContainerProps = {
  className?: string;
  missionId: number;
};

const MissionDetailsBetRedirectionButtonContainer = ({
  className = '',
  missionId,
}: MissionDetailsBetRedirectionButtonContainerProps) => {
  const { history } = useRouter();
  const dispatch = useDispatch();
  const selectorProps = useMemo(() => ({ missionId, history, dispatch }), [missionId, history, dispatch]);
  const { onClick, label } = useSelector((state: StateType) =>
    selectMissionDetailsBetRedirectionButtonContainerProps(state, selectorProps),
  );

  return onClick ? (
    <StyledPrimaryButton className={className} label={label} onClick={onClick} SVGIcon={GridArrowRight} />
  ) : null;
};

export default MissionDetailsBetRedirectionButtonContainer;
